import {Component, OnInit, ViewChild} from '@angular/core';
import {
    // @ts-ignore
    ContactTypeStats,
    ColumnFilter,
    DataTableColumnData,
    DataTableConfig,
    DataTableObservableCompletionListener,
    DataTableObservableDataSource,
    DataTableObservableErrorListener, DataTableObservableRefresher, TableAction, DataTableDataSource, DatatableComponent, AdminDashboardApiService
} from '@cas-hub/acabim-common-client';
import {tap, map} from 'rxjs/operators';

@Component({
    selector: 'acabim-admin-user-type-stats',
    templateUrl: './user-type-stats.component.html',
    styleUrls: ['./user-type-stats.component.scss']
})
export class UserTypeStatsComponent implements OnInit {
    @ViewChild(DatatableComponent) public dataTable?: DatatableComponent;

    public dataSources: DataTableDataSource<any>[] = [];

    constructor(private readonly adminDashboardService: AdminDashboardApiService) {
    }

    ngOnInit(): void {
        this.dataSources.push(new UserTypeDS(this.userTypeDS, undefined, undefined));

    }

    private get userTypeDS(): DataTableObservableRefresher<ContactTypeStats> {
        return () => this.adminDashboardService.getContactStats()
            .pipe(tap(data => {
                data.contactTypes = [{contactType: 'Contacts', count: data.contactCount}].concat(data.contactTypes);
            }), map(data => data.contactTypes as ContactTypeStats[]));
    }

}

export class UserTypeDS<T extends ContactTypeStats> extends DataTableObservableDataSource<T> {

    readonly columnData: DataTableColumnData[] =
        [
            {displayName: 'User Type', objectPropertyName: 'contactType', colWidth: '75%'},
            {displayName: 'Persons', objectPropertyName: 'count', colWidth: '25%', textAlign: 'right'}
        ];
    readonly config: DataTableConfig = {
        tableHeading: '',
        isSearchEnabled: false,
        searchPlaceHolder: 'Search Space',
        emptyMessage: '',
        globalFilterFields: [],
        hasCheckbox: false,
        hasDetailsButton: false,
        isLazyLoadingEnabled: false,
        isPaginationEnabled: false,
        hasFilters: false,
        isExportEnabled: false,
        hasActions: false
    };
    readonly columnFilters: ColumnFilter[] = [];
    readonly actions: TableAction[] = [];

    onDataExpanded(value: ContactTypeStats): void {
    }

    constructor(readonly dataRefresher: DataTableObservableRefresher<T>,
                readonly observableErrorListener?: DataTableObservableErrorListener,
                readonly observableCompleteListener?: DataTableObservableCompletionListener,
                readonly actionListener?: (action: TableAction) => void) {
        super(() => this.dataRefresher(), observableErrorListener, observableCompleteListener);
    }

    onAction(action: TableAction): void {
        if (this.actionListener) {
            this.actionListener(action);
        }
    }

    onDataFiltered(): void {
    }

}
